module.exports = __webpack_public_path__ + "img/arrow-right-circle.7996ff08.svg";